
import { SVGProps } from 'react';

export default function RadioSelected(props: Partial<SVGProps<any>>) {
  return (
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <g filter="url(#filter0_d_3961_1103)">
    <rect x="1.75" y="0.75" width="14.5" height="14.5" rx="7.25" stroke="#878787" strokeWidth="1.5" shape-rendering="crispEdges"/>
  </g>
  <g filter="url(#filter1_d_3961_1103)">
    <rect x="1" width="16" height="16" rx="8" fill="white"/>
    <rect x="1.75" y="0.75" width="14.5" height="14.5" rx="7.25" stroke="#FF00FE" strokeWidth="1.5"/>
  </g>
  <rect x="5" y="4" width="8" height="8" rx="4" fill="#FF00FE"/>
  <defs>
    <filter id="filter0_d_3961_1103" x="0" y="0" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="1"/>
      <feGaussianBlur stdDeviation="0.5"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3961_1103"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3961_1103" result="shape"/>
    </filter>
    <filter id="filter1_d_3961_1103" x="0" y="0" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="1"/>
      <feGaussianBlur stdDeviation="0.5"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3961_1103"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3961_1103" result="shape"/>
    </filter>
  </defs>
</svg>


  )
}